import { render } from "./view-purchase.vue?vue&type=template&id=b913c736&scoped=true"
import script from "./view-purchase.vue?vue&type=script&lang=js"
export * from "./view-purchase.vue?vue&type=script&lang=js"

import "./view-purchase.vue?vue&type=style&index=0&id=b913c736&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b913c736"]])

export default __exports__